import { Abstrap } from '../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'label' };

class FormLabel extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-form__label',
            className,
        ];
    }

}

FormLabel.propTypes = propTypes;

FormLabel.defaultProps = defaultProps;

export default FormLabel;
